<p-dialog [header]="message" [(visible)]="visible" [modal]="true" [style]="{width: '520px'}" (onHide)="cancelAction()">
  <form [formGroup]="formProfile" class="space-y-4 pt-2">

    <!-- Nombre -->
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Nombre</label>
      <input pInputText formControlName="name" placeholder="Campo obligatorio" autocomplete="off" class="w-full mt-1" />
    </div>

    <!-- Correo Electrónico -->
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Correo Electrónico</label>
      <div class="relative mt-1">
        <input pInputText type="text" formControlName="email" placeholder="Campo obligatorio" autocomplete="off"
          class="w-full" [ngClass]="{'border-green-500': isButtonEmail}" (blur)="onEmailBlur()" />
        @if(isButtonEmail) {
          <i class="pi pi-check-circle text-green-500 absolute right-3 top-1/2 -translate-y-1/2"></i>
        }
      </div>
      @if(sendingEmailOtp && !showInlineEmailOtp) {
        <small class="text-vivid-royal-400 flex items-center gap-1 mt-1"><i class="pi pi-spin pi-spinner text-xs"></i> Enviando código...</small>
      }
      @if(email.touched && email.errors?.['email']) {
        <small class="text-red-500">El correo electrónico no es válido</small>
      }
      @if(email.touched && email.errors?.['duplicate'] && email.value !== '') {
        <small class="text-red-500">El correo ya está asignado a otro usuario</small>
      }
      @if(showInlineEmailOtp) {
        <app-inline-otp type="email" [target]="email.value"
          (verified)="onInlineEmailVerified($event)"
          (cancelled)="onInlineEmailCancelled()"
          (resend)="onResendEmail()" />
      }
      @if(!isNewUser && email.disabled) {
        <small class="text-vivid-royal-400 flex items-center gap-1 mt-1"><i class="pi pi-lock text-xs"></i> No editable por seguridad. Para cambiar, elimine y cree un nuevo usuario.</small>
      }
    </div>

    <!-- Teléfono -->
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Teléfono</label>
      <div class="flex gap-2 mt-1">
        <button pButton type="button" class="p-button-sm p-button-outlined w-28" [disabled]="!isNewUser || isButtonOTP" (click)="toggleLadaList()">
          <img [src]="selectedLada === '+1' ? './assets/icons/united-states-flag-icon.svg' : './assets/icons/mexico-flag-icon.svg'" class="h-3.5 w-5 mr-1.5" />
          <span>{{ selectedLada }}</span>
          <i class="pi pi-chevron-down text-xs ml-1"></i>
        </button>
        <div class="relative flex-1">
          <input pInputText formControlName="phone" mask="(000) 000-0000"
            [specialCharacters]="[' ','(',')','-']"
            placeholder="(___) ___-____" class="w-full" autocomplete="off"
            [ngClass]="{'border-green-500': isButtonOTP}" (blur)="onPhoneBlur()" />
          @if(isButtonOTP) {
            <i class="pi pi-check-circle text-green-500 absolute right-3 top-1/2 -translate-y-1/2"></i>
          }
        </div>
      </div>
      @if(showLadaList) {
        <div class="bg-white dark:bg-crayola-blue-800 border border-dark-khaki-200 dark:border-vivid-royal-700 rounded-lg shadow-lg mt-1 z-20 absolute w-64">
          <button type="button" class="w-full px-4 py-2 text-sm text-left hover:bg-dark-khaki-100 dark:hover:bg-vivid-royal-800 flex items-center gap-2" (click)="selectLada('+1')">
            <img src="./assets/icons/united-states-flag-icon.svg" class="h-4 w-5" /> United States (+1)
          </button>
          <button type="button" class="w-full px-4 py-2 text-sm text-left hover:bg-dark-khaki-100 dark:hover:bg-vivid-royal-800 flex items-center gap-2" (click)="selectLada('+52')">
            <img src="./assets/icons/mexico-flag-icon.svg" class="h-4 w-5" /> México (+52)
          </button>
        </div>
      }
      @if(sendingPhoneOtp && showInlinePhoneOtp === false) {
        <small class="text-vivid-royal-400 flex items-center gap-1 mt-1"><i class="pi pi-spin pi-spinner text-xs"></i> Enviando código...</small>
      }
      @if(phone.touched && phone.errors?.['duplicate']) {
        <small class="text-red-500">El teléfono ya está asignado a otro usuario</small>
      }
      @if(showInlinePhoneOtp) {
        <app-inline-otp type="phone" [target]="phone.value"
          (verified)="onInlinePhoneVerified($event)"
          (cancelled)="onInlinePhoneCancelled()"
          (resend)="onResendPhone()" />
      }
      @if(!isNewUser && phone.disabled) {
        <small class="text-vivid-royal-400 flex items-center gap-1 mt-1"><i class="pi pi-lock text-xs"></i> No editable por seguridad. Para cambiar, elimine y cree un nuevo usuario.</small>
      }
    </div>

    <!-- Puesto -->
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Puesto</label>
      <input pInputText formControlName="position" placeholder="Campo obligatorio" autocomplete="off" class="w-full mt-1" />
    </div>

    <!-- Tipo de Acceso -->
    <div>
      <div class="flex justify-between items-center">
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Tipo de Acceso</label>
        <button pButton icon="pi pi-info-circle" class="p-button-rounded p-button-text p-button-sm"
          pTooltip="Ver roles" (click)="showModal = true"></button>
      </div>
      <p-select [options]="accessTypeOptions" [(ngModel)]="accessType" optionLabel="label" optionValue="value"
        (onChange)="onUserTypeChangeFromSelect($event)" class="w-full mt-1" />
    </div>

    @if(msgError.length > 0) {
      <small class="text-red-500" [innerHTML]="msgError[0]"></small>
    }
    @if(msgResponse) {
      <small class="text-red-500" [innerHTML]="msgResponse"></small>
    }
  </form>

  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="cancelAction()"></button>
    <button pButton [label]="saving ? 'Guardando...' : txtConfirmButton" [icon]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'" [disabled]="saving || inProcess || formProfile.invalid || !isButtonEmail || !isButtonOTP" (click)="confirmAction()"></button>
  </ng-template>
</p-dialog>

<app-user-info-modal *ngIf="showModal" [message]="'Roles de usuarios'" (onCancel)="showModal = false"></app-user-info-modal>
